import {
  DISPLAY_HIDE_MODAL,
  UPDATE_UPGRADE_JOURNEY_STATUS,
  CLEAR_UPGRADE_JOURNEY_STATUS,
  CLEAR_ENTIRE_JOURNEY,
  UPDATE_CAN_RECEIVE_OTP,
  UPDATE_MSISDN_STATUS,
  UPDATE_ELIGIBILITY_CHECK_STATUS,
  UPDATE_DISPLAY_DATA,
  UPDATE_SELECTED_DISPLAY_DATA,
  INVALID_OTP,
  UPDATE_ELIGIBILITY_DATA,
  ADD_ALTERNATE_NUMBERS,
  TOP_BANNER_TOGGLE,
  TOP_BANNER_MODAL_TOGGLE,
  STOP_UPGRADE_MODAL_TOGGLE,
  UPDATE_SELECTED_UPGRADE_DATA,
  UPDATE_UPGRADE_DATA,
  UPDATE_UPGRADE_REDIRECT,
  UPDATE_LOGGED_IN_USER_ELIGIBILITY_DATA,
  UPDATE_UNMASKED_MSISDN,
  ADD_CREDIT_PROFILE,
  GET_UPGRADE_CONSUMPTION,
  GET_PAST_USAGE,
  GET_UPGRADE_BRANDS,
  GET_UPGRADE_MODELS,
  GET_RECOMMENDED_DEALS,
  UPDATE_CHECK_DEAL_QUALIFIES,
  RESET_INVALID_OTPS,
  TOGGLE_SNACK_BAR,
  DEAL_PRICE,
  UPDATE_DEAL_GRID_RESET,
  UPDATE_DEAL_SELECTION_RESET,
  UPDATE_PRODUCT_GRID_RESET,
  UPDATE_LINKED_NUMBER,
  PAST_TOKEN,
  MSISDN_BLOCKED,
  DISPLAY_INVALID_OTP_ERROR,
  UPDATE_NEXT_MSISDN_SELECTED,
  ADD_DEAL_TO_CART,
} from "../actionTypes/index";
import { errorCodes, maskMsisdn, upgradeStages } from "../../services/upgradeService";
import config from "../../config/index";

const initialState = {
  showModal: false,
  upgradeStatus: "number entry",
  msisdn: "",
  unMaskedMsisdn: "",
  canReciveOTP: true,
  linkedNumbers: [],
  selectedLinkedNumber: "",
  invalidOTPTries: 0,
  upgradeCheckDone: false,
  upgradeResponse: {},
  selectedUpgradeResponse: {},
  selectedUpgradeMsisdn: "",
  upgradeDisplayData: {},
  selectedUpgradeDisplayData:{},
  resultCode: "",
  topBannerVisible: true,
  topBannerModal: false,
  stopBannerModal: false,
  creditFilters: {},
  allUpgradesData: [],
  upgradeLink: {
    link: "",
    text: ""
  },
  pastUsageData: {},
  manufacturers: [],
  deviceModels: [],
  recommendedSkus: [],
  checkIsDealAffordable: false,
  showSnackBar: false,
  eligibleUpgradeList: [],
  devicePrice: {
    devicePrice: 0,
    installment: 0
  },
  resetDealGrid: false,
  resetDealSelection: false,
  resetProductGrid: false,
  isChildAllowed: false,
  responseToken:"",
  dealApiError: false,
  displayInvalidOTPError: false,
  isNextMsisdnSelected: false,
  addDeal: false
};

const upgradeReducer = (state = initialState, action) => {
  switch (action.type) {
    case DISPLAY_HIDE_MODAL:
      return {
        ...state,
        showModal: action.payload,
      };
    case TOP_BANNER_TOGGLE:
      return {
        ...state,
        topBannerVisible: action.payload,
      };
    case TOP_BANNER_MODAL_TOGGLE:
      return {
        ...state,
        topBannerModal: action.payload,
      };
    case STOP_UPGRADE_MODAL_TOGGLE:
      return {
        ...state,
        stopBannerModal: action.payload,
      };
    case UPDATE_UPGRADE_JOURNEY_STATUS:
      return {
        ...state,
        upgradeStatus: action.payload.status,
        resultCode: action.payload.code,
      };
    case CLEAR_UPGRADE_JOURNEY_STATUS:
      return {
        ...state,
        showModal: false,
        upgradeStatus: upgradeStages.NUMBER_ENRTY,
        invalidOTPTries: 0,
        canReciveOTP: true,
        linkedNumbers: [],
        upgradeResponse: {},
        selectedUpgradeResponse: {},
        upgradeDisplayData: {},
        selectedUpgradeDisplayData: {},
        resultCode: null,
        allUpgradesData: [],
        upgradeCheckDone: false,
        topBannerVisible: false,
        checkIsDealAffordable: false,
        showSnackBar: false,
        eligibleUpgradeList: [],
        creditFilters: {},
        resetDealGrid: true,
        resetDealSelection: true,
        resetProductGrid: true,
        selectedLinkedNumber: "",
        isChildAllowed: false,
        displayInvalidOTPError: false,
        manufacturers: [],
        upgradeLink: {
          link: "",
          text: ""
        },
        addDeal: false
      };
    case CLEAR_ENTIRE_JOURNEY:
      return initialState
    case UPDATE_DEAL_GRID_RESET:
      return {
        ...state,
        resetDealGrid: false
      }
    case UPDATE_DEAL_SELECTION_RESET:
      return {
        ...state,
        resetDealSelection: false
      }
    case UPDATE_PRODUCT_GRID_RESET:
      return {
        ...state,
        resetProductGrid: false
      }
    case UPDATE_CAN_RECEIVE_OTP:
      return {
        ...state,
        canReciveOTP: action.payload,
      };
    case UPDATE_MSISDN_STATUS:
      return {
        ...state,
        msisdn: action.payload.number,
      };
    case UPDATE_ELIGIBILITY_CHECK_STATUS:
      return {
        ...state,
        upgradeCheckDone: action.payload,
        topBannerVisible: action.payload
      };
    case UPDATE_ELIGIBILITY_DATA:
    {
      let currentUpgrade = [];
      let isCurrentUpgradeMah = false;
      let isChildAllowed = false;
      if (
        action.payload.data?.result?.result &&
        action.payload.data?.result?.result.length
      ) {
        action.payload.data?.result?.result.forEach(item => {
          if(maskMsisdn(item.msisdn) === maskMsisdn(state.selectedLinkedNumber)){
            isChildAllowed = !item?.mah;
          }
        })
        currentUpgrade = action.payload.data?.result?.result.filter((item) => {
          if (maskMsisdn(item.msisdn) === maskMsisdn(state.unMaskedMsisdn)) {
            isCurrentUpgradeMah = item?.mah;
            return item
          }
        });
      }
      let newUpgrade = {};

      if(currentUpgrade.length) {
        newUpgrade = currentUpgrade[0];
      } else {
        if(action.payload.data?.result?.result[0]?.msisdn) {
          newUpgrade = {}
        } else {
          newUpgrade = action.payload.data?.result?.result[0]
        }
      }
      return {
        ...state,
        resultCode:newUpgrade?.resultCode? newUpgrade.resultCode?.toLowerCase() : errorCodes.user_acc_error,
        upgradeResponse: newUpgrade ,
        allUpgradesData: !isCurrentUpgradeMah?  currentUpgrade : action.payload.data?.result?.result,
        isChildAllowed: isChildAllowed
      };}
    case UPDATE_DISPLAY_DATA:
      return {
        ...state,
        upgradeDisplayData: action.payload,
      };
    case UPDATE_SELECTED_DISPLAY_DATA:
      return {
        ...state,
        selectedUpgradeDisplayData: action.payload,
      };
    case INVALID_OTP:
      return {
        ...state,
        invalidOTPTries: state.invalidOTPTries + 1,
        displayInvalidOTPError: true,
      };
    case MSISDN_BLOCKED:
      return {
        ...state,
        invalidOTPTries: config.maxRetriesCount,
      }
    case ADD_ALTERNATE_NUMBERS:
      return {
        ...state,
        linkedNumbers: action.payload.data,
      };
    case UPDATE_LOGGED_IN_USER_ELIGIBILITY_DATA: {
      let eligibleUpgrade = [];
      if (
        action.payload.data &&
        action.payload.data.length
      ) {

        eligibleUpgrade = action.payload.data.filter(item => {
          if(item.upgradeEligible) {
            return item;
          }
        })
      }
      return {
        ...state,
        resultCode: eligibleUpgrade.length ? eligibleUpgrade[0].resultCode?.toLowerCase() : action.payload.data[0]?.resultCode?.toLowerCase(),
        upgradeResponse: eligibleUpgrade.length? eligibleUpgrade[0] : action.payload.data[0] || {},
        selectedUpgradeResponse: eligibleUpgrade.length? eligibleUpgrade[0] : action.payload.data[0] || {},
        allUpgradesData:  action.payload.data,
        showSnackBar: eligibleUpgrade.length > 0,
        eligibleUpgradeList: eligibleUpgrade,
        msisdn: sessionStorage.getItem('upgradeMsisdn'),
        unMaskedMsisdn: "",
        selectedUpgradeMsisdn: ""
      };
    }
    case ADD_CREDIT_PROFILE:
      return {
        ...state,
        creditFilters: action.payload
      }
    case UPDATE_SELECTED_UPGRADE_DATA: {
      return {
        ...state,
        resultCode: action.payload.resultCode?.toLowerCase(),
        selectedUpgradeResponse: action.payload.data,
        msisdn: action.payload.msisdn,
        selectedUpgradeMsisdn:  action.payload.data?.msisdn
      }
    }
    case UPDATE_UPGRADE_DATA: {
      return {
        ...state,
        resultCode: action.payload.resultCode?.toLowerCase(),
        upgradeResponse: action.payload.data,
        msisdn: action.payload.msisdn,
      }
    }
    case UPDATE_UPGRADE_REDIRECT: {
      return {
        ...state,
        upgradeLink: action.payload
      }
    }
    case UPDATE_UNMASKED_MSISDN: {
      return {
        ...state,
        unMaskedMsisdn: action.payload
      };
    }
    case GET_PAST_USAGE: {
      return {
        ...state,
        pastUsageData: action.payload.data
      };
    }
    case GET_UPGRADE_BRANDS: {
      return {
        ...state,
        manufacturers: action.payload.data
      };
    }
    case GET_UPGRADE_MODELS: {
      return {
        ...state,
        deviceModels: action.payload.data
      };
    }
    case GET_RECOMMENDED_DEALS: {
      return {
        ...state,
        recommendedSkus: action.payload.data,
        dealApiError:action.payload.error
      };
    }
    case GET_UPGRADE_CONSUMPTION: {
      return {
        ...state,
        pastConsumptionData: action.payload.data
      };
    }
    case UPDATE_CHECK_DEAL_QUALIFIES: {
      return {
        ...state,
        checkIsDealAffordable: action.payload
      }
    }
    case RESET_INVALID_OTPS: {
      return {
        ...state,
        invalidOTPTries: 0
      }
    }
    case TOGGLE_SNACK_BAR: {
      return {
        ...state,
        showSnackBar: action.payload
      }
    }
    case DEAL_PRICE: {
      return {
        ...state,
        devicePrice: action.payload
      }
    }
    case UPDATE_LINKED_NUMBER: {
      return{
        ...state,
        selectedLinkedNumber: action.payload
      }
    }
    case PAST_TOKEN: {
      return {
        ...state,
        responseToken: action.payload?.token
      }
    }
    case DISPLAY_INVALID_OTP_ERROR: {
      return {
        ...state,
        displayInvalidOTPError: action.payload
      }
    }
    case UPDATE_NEXT_MSISDN_SELECTED: {
      return{
        ...state,
        isNextMsisdnSelected: action.payload
      }
    }
    case ADD_DEAL_TO_CART: {
      return{
        ...state,
        addDeal: action.payload
      }
    }
    default:
      return state;
  }
};
export default upgradeReducer;